import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.SHARE_A_SALE;

export const ShareASaleDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const ShareASaleSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
